var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("validation-observer", { ref: "evalutatorAssignmentFromRef" }, [
        _c(
          "div",
          {
            staticClass:
              "bg-secondary-1 mt-4 p-4 d-flex justify-content-between"
          },
          [
            _c(
              "div",
              [
                _c("section-title", {
                  staticClass: "section-title",
                  attrs: {
                    "bg-icon": "bg-white",
                    "has-line": false,
                    icon: "fas fa-users text-orange",
                    reverse: true,
                    title:
                      "Asignar Propuesta a Evaluadores (Seleccione Evaluador)"
                  }
                }),
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                "custom-error-msg":
                                  "Favor seleccione un evaluador.",
                                error: errors[0],
                                fieldkey: "userId",
                                fieldname: "fullName",
                                options: _vm.evaluatorsToAssaing,
                                placeholder: "Seleccione"
                              },
                              model: {
                                value: _vm.evaluatorToAssaing,
                                callback: function($$v) {
                                  _vm.evaluatorToAssaing = $$v
                                },
                                expression: "evaluatorToAssaing"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    548562585
                  )
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center align-items-center"
              },
              [
                _c(
                  "action-button",
                  {
                    staticClass: "py-2 px-4 mr-md-2",
                    attrs: {
                      i: "fa fa-times-circle",
                      variant: "outline-danger"
                    },
                    on: { click: _vm.onCancelHandler }
                  },
                  [_vm._v(" Cancelar ")]
                ),
                _c(
                  "action-button",
                  {
                    staticClass: "py-2 px-4",
                    attrs: { variant: "success" },
                    on: { click: _vm.onAddHandler }
                  },
                  [_vm._v(" Asignar ")]
                )
              ],
              1
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }